function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M24.7592 23.3333L25.5421 27.5319C25.5705 27.6993 25.5539 27.8696 25.4936 28.0316C25.4333 28.1936 25.3305 28.3436 25.1921 28.4718C25.0537 28.5999 24.8828 28.7034 24.6905 28.7752C24.4982 28.8471 24.2891 28.8858 24.0766 28.8888H15.9264C15.713 28.8884 15.5021 28.8514 15.3083 28.7804C15.1144 28.7093 14.9421 28.6059 14.8031 28.4771C14.664 28.3484 14.5614 28.1973 14.5024 28.0342C14.4434 27.871 14.4292 27.6997 14.461 27.5319L15.2238 23.3333",
  stroke: "#E25B0D",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M27.0457 11.1111H12.9542C11.9363 11.1111 11.1111 11.9759 11.1111 13.0428V21.4016C11.1111 22.4685 11.9363 23.3333 12.9542 23.3333H27.0457C28.0637 23.3333 28.8889 22.4685 28.8889 21.4016V13.0428C28.8889 11.9759 28.0637 11.1111 27.0457 11.1111Z",
  stroke: "#E25B0D",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("line", {
  x1: 16.6667,
  y1: 26.1667,
  x2: 22.2222,
  y2: 26.1667,
  stroke: "#E25B0D",
  strokeLinejoin: "round"
});

var SvgCashRegistersTablet = function SvgCashRegistersTablet(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCashRegistersTablet, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cash-registers-tablet.16ea7251.svg";
export { ForwardRef as ReactComponent };